export enum ScheduleType {
  Regular = 'Regular',
  Smart = 'Smart',
  Audio = 'Audio'
}
